import React from 'react';
import {
  Box,
  BoxProps,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Flex,
  Spinner,
  VStack,
} from '@chakra-ui/react';
import {
  useIntegrationStaticInfo,
  useIntegrationFromContext,
} from './IntegrationDetailsContext';
import {IntegrationStatus} from '../../shared/integrations/common';
import {AllIntegrations} from './AllIntegrations';
import {Link as ReactRouterLink} from 'react-router-dom';

export const IntegrationDetailsHeader = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  const integration = useIntegrationFromContext();
  const integrationInfo = useIntegrationStaticInfo();

  return (
    <Flex direction="column" py={4} px={8} bgColor={'kgray.100'}>
      <Breadcrumb separator={'>'}>
        <BreadcrumbItem>
          <BreadcrumbLink as={ReactRouterLink} to={'/settings/integrations'}>
            Integrations
          </BreadcrumbLink>
        </BreadcrumbItem>

        <BreadcrumbItem isCurrentPage>
          <BreadcrumbLink>
            {AllIntegrations[integration.type].label}
          </BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>

      <Flex m={8} alignItems={'center'} gap={8}>
        <Flex
          width="100px"
          height="100px"
          bgColor={'white'}
          borderRadius={'lg'}
          p={4}
          flexShrink={0}
        >
          {integrationInfo.logo}
        </Flex>

        <VStack flexGrow={1} alignItems={'start'}>
          <Box fontSize={'2xl'}>{integrationInfo.label}</Box>
          <StatusBadge status={integration.status} />
        </VStack>

        {children}
      </Flex>
    </Flex>
  );
};

const StatusText = {
  active: 'Connected',
  disconnected: 'Disconnected',
  refresh_token_expired: 'Auth Error',
} satisfies Record<IntegrationStatus, string>;

const StatusStyle = {
  active: {
    bgColor: 'kgreen.100',
    color: 'kgreen.500',
  },
  disconnected: {
    bgColor: 'kyellow.100',
    color: 'kgray.400',
  },
  refresh_token_expired: {
    bgColor: 'kred.100',
    color: 'kred.500',
  },
} satisfies Record<IntegrationStatus, Partial<BoxProps>>;

const StatusBadge = ({
  status,
  ...props
}: BoxProps & {
  status?: IntegrationStatus;
}) => {
  if (!status) {
    return <Spinner size="sm" />;
  }

  return (
    <Box
      borderRadius={'md'}
      fontSize={'xs'}
      p={1}
      textTransform={'uppercase'}
      {...StatusStyle[status]}
      {...props}
    >
      {StatusText[status]}
    </Box>
  );
};
